import { joinBy } from '@pbk/utils';
export const getFullPathFromUrl = (url) => {
    return joinBy([url.pathname, url.search, url.hash], '');
};
